/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_TitleInputs */

const en_file_import_title = /** @type {(inputs: File_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Import`)
};

const fr_file_import_title = /** @type {(inputs: File_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Import`)
};

const de_file_import_title = /** @type {(inputs: File_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiimport`)
};

const it_file_import_title = /** @type {(inputs: File_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione file`)
};

const ru_file_import_title = /** @type {(inputs: File_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт файлов`)
};

const es_file_import_title = /** @type {(inputs: File_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de archivos`)
};

const zh_cn2_file_import_title = /** @type {(inputs: File_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件导入`)
};

const ja_file_import_title = /** @type {(inputs: File_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルのインポート`)
};

const hi_file_import_title = /** @type {(inputs: File_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल आयात`)
};

const pt_pt2_file_import_title = /** @type {(inputs: File_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de Arquivos`)
};

/**
* | output |
* | --- |
* | "File Import" |
*
* @param {File_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_title = /** @type {((inputs?: File_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_import_title(inputs)
	if (locale === "de") return de_file_import_title(inputs)
	if (locale === "it") return it_file_import_title(inputs)
	if (locale === "ru") return ru_file_import_title(inputs)
	if (locale === "es") return es_file_import_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_import_title(inputs)
	if (locale === "ja") return ja_file_import_title(inputs)
	if (locale === "hi") return hi_file_import_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_import_title(inputs)
	return en_file_import_title(inputs)
});